_ = require 'underscore'
CustomField = require 'models/custom-field'
OptionEditorView = require 'views/custom-field/option-editor-view'
PopOver = require 'views/lib/pop-over'
Promise = require 'bluebird'
View = require 'view'
Util = require 'lib/util'
t = require('views/internal/teacup-with-helpers')('custom_fields')
trackUe = require 'debug/trackUe'

CUSTOM_FIELDS_ID = require 'data/custom-fields-id'

template = t.renderable ({ selectedType, name, isDuplicate }) ->
  t.form ->
    t.label { for: 'field-create-type' }, ->
      t.format 'type'
    t.select '.js-field-type-select', { id: 'field-create-type', name: 'type' }, ->
      CustomField.types.forEach (type) ->
        t.option { value: type, selected: selectedType == type }, ->
          t.format type
    t.label { for: 'field-create-name' }, ->
      t.format 'name'
    t.input '.js-field-name-input',
      autoselect: true
      class: t.classify({ 'is-invalid': isDuplicate })
      id: 'field-create-name'
      maxlength: 1000
      name: 'name'
      required: true
      spellcheck: true
      type: 'text'
      value: name
    t.p '.custom-field-error-message.js-duplicate-error', class: t.classify({ hide: !isDuplicate }), ->
      t.format 'duplicate field'
    t.div '.js-options-container'
    t.input '.primary.js-save-field',
      disabled: name.length == 0 || isDuplicate,
      type: 'submit',
      value: t.l 'create'

module.exports = class CustomFieldCreateView extends View
  viewTitleKey: 'new field'

  events:
    'click .js-save-field': 'createField'
    'input .js-field-name-input': 'validateFieldName'
    'change .js-field-type-select': 'changeType'

  initialize: ->
    @board = @options.board

  isDuplicate: ->
    name = @name ? ''
    type = @selectedType ? 'checkbox'
    @board.hasCustomField(type, name)

  render: ->
    isDuplicate = @isDuplicate()
    @$el.html template({ name: @name ? '', isDuplicate, selectedType: @selectedType })

    if @selectedType == 'list'
      @optionEditor = @subview(OptionEditorView, @model, {}, 'new-field-options-editor')
      @appendSubview @optionEditor, @$('.js-options-container')

    @

  changeType: (e) ->
    @selectedType = @$(e.target).val()
    @render()

  validateFieldName: (e) ->
    $el = @$(e.target)
    newVal = $el.val().trim()
    @name = newVal
    isDuplicate = @isDuplicate()
    @$('.js-save-field').prop('disabled', @name.length == 0 || isDuplicate)
    @$('.js-field-name-input').toggleClass('is-invalid', isDuplicate)
    @$('.js-duplicate-error').toggleClass('hide', !isDuplicate)


  createField: (e) ->
    Util.stop(e)
    $elem = @$(e.target)
    $form = $elem.closest('form')
    type = $form.find('.js-field-type-select').val()
    name = $form.find('.js-field-name-input').val().trim()

    if name == ''
      return

    # disable button to prevent double submission
    $elem.prop('disabled', true)

    newCustomField =
      idModel: @board.id
      modelType: 'board'
      name: name
      pos: 'bottom'
      type: type

    if type == 'list'
      newCustomField.options = @optionEditor.getOptions()

    trackUe 'card-detail',
      'creates',
      'custom fields definition',
      type,
      '',
      'by clicking the save button',
      CUSTOM_FIELDS_ID

    new Promise (resolve) =>
      @board
      .customFieldList
      .create(newCustomField, { success: resolve })
    .then ->
      PopOver.popView()
    .done()



// WEBPACK FOOTER //
// ./app/scripts/views/custom-field/custom-field-create-view.coffee